const Staking = {
  abi: [
    {
      constant: true,
      inputs: [],
      name: "_withdrawalPublisher",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "_authorizedNewOwner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "_fallbackMaxDepositIncluded",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        { internalType: "bytes32", name: "root", type: "bytes32" },
        { internalType: "uint256", name: "nonce", type: "uint256" },
        { internalType: "bytes32[]", name: "replacedRoots", type: "bytes32[]" },
      ],
      name: "addWithdrawalRoot",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "_immediatelyWithdrawableLimit",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: false,
      inputs: [{ internalType: "bytes32[]", name: "roots", type: "bytes32[]" }],
      name: "removeWithdrawalRoots",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "_fallbackPublisher",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "_nonceToPendingDeposit",
      outputs: [
        { internalType: "address", name: "depositor", type: "address" },
        { internalType: "uint256", name: "amount", type: "uint256" },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "_depositNonce",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "_tokenAddress",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        { internalType: "address", name: "forAddress", type: "address" },
      ],
      name: "renounceWithdrawalAuthorization",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [],
      name: "resetFallbackMechanismDate",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        { internalType: "address", name: "toAddress", type: "address" },
        {
          internalType: "uint256",
          name: "maxCumulativeAmountWithdrawn",
          type: "uint256",
        },
        { internalType: "bytes32[]", name: "merkleProof", type: "bytes32[]" },
      ],
      name: "withdrawFallback",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "_fallbackWithdawalDelaySeconds",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
      name: "_withdrawalRootToNonce",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "_fallbackSetDate",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        { internalType: "uint256", name: "depositNonce", type: "uint256" },
      ],
      name: "refundPendingDeposit",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        { internalType: "address", name: "authorizedAddress", type: "address" },
      ],
      name: "authorizeOwnershipTransfer",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "newFallbackPublisher",
          type: "address",
        },
      ],
      name: "setFallbackPublisher",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "uint256",
          name: "newFallbackDelaySeconds",
          type: "uint256",
        },
      ],
      name: "setFallbackWithdrawalDelay",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        { internalType: "bytes32", name: "root", type: "bytes32" },
        {
          internalType: "uint256",
          name: "maxDepositIncluded",
          type: "uint256",
        },
      ],
      name: "setFallbackRoot",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [{ internalType: "int256", name: "amount", type: "int256" }],
      name: "modifyImmediatelyWithdrawableLimit",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        { internalType: "address", name: "toAddress", type: "address" },
        { internalType: "uint256", name: "amount", type: "uint256" },
        {
          internalType: "uint256",
          name: "maxAuthorizedAccountNonce",
          type: "uint256",
        },
        { internalType: "bytes32[]", name: "merkleProof", type: "bytes32[]" },
      ],
      name: "withdraw",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [],
      name: "assumeOwnership",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "_owner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: false,
      inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
      name: "deposit",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "_fallbackRoot",
      outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "_addressToWithdrawalNonce",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "newWithdrawalPublisher",
          type: "address",
        },
      ],
      name: "setWithdrawalPublisher",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "_maxWithdrawalRootNonce",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "_addressToCumulativeAmountWithdrawn",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "_immediatelyWithdrawableLimitPublisher",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "tokenAddress", type: "address" },
        { internalType: "address", name: "fallbackPublisher", type: "address" },
        {
          internalType: "address",
          name: "withdrawalPublisher",
          type: "address",
        },
        {
          internalType: "address",
          name: "immediatelyWithdrawableLimitPublisher",
          type: "address",
        },
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "rootHash",
          type: "bytes32",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "nonce",
          type: "uint256",
        },
      ],
      name: "WithdrawalRootHashAddition",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "rootHash",
          type: "bytes32",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "nonce",
          type: "uint256",
        },
      ],
      name: "WithdrawalRootHashRemoval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "rootHash",
          type: "bytes32",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "maxDepositNonceIncluded",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "setDate",
          type: "uint256",
        },
      ],
      name: "FallbackRootHashSet",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "depositor",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "nonce",
          type: "uint256",
        },
      ],
      name: "Deposit",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "toAddress",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "rootNonce",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "authorizedAccountNonce",
          type: "uint256",
        },
      ],
      name: "Withdrawal",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "toAddress",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
      ],
      name: "FallbackWithdrawal",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "depositorAddress",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "nonce",
          type: "uint256",
        },
      ],
      name: "PendingDepositRefund",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "forAddress",
          type: "address",
        },
      ],
      name: "RenounceWithdrawalAuthorization",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "oldValue",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "newValue",
          type: "uint256",
        },
      ],
      name: "FallbackWithdrawalDelayUpdate",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "newDate",
          type: "uint256",
        },
      ],
      name: "FallbackMechanismDateReset",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "oldValue",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "newValue",
          type: "uint256",
        },
      ],
      name: "ImmediatelyWithdrawableLimitUpdate",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "authorizedAddress",
          type: "address",
        },
      ],
      name: "OwnershipTransferAuthorization",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "oldValue",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newValue",
          type: "address",
        },
      ],
      name: "OwnerUpdate",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "oldValue",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newValue",
          type: "address",
        },
      ],
      name: "FallbackPublisherUpdate",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "oldValue",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newValue",
          type: "address",
        },
      ],
      name: "WithdrawalPublisherUpdate",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "oldValue",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newValue",
          type: "address",
        },
      ],
      name: "ImmediatelyWithdrawableLimitPublisherUpdate",
      type: "event",
    },
  ],
};

export default Staking;
